module.exports = __webpack_public_path__ + "img/honor01.8993e9ff.webp";